import { Link } from "react-router-dom";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { logout } from "../services/authService";
import styled from "styled-components";
import { useTheme } from "@mui/material/styles";
import { LogOut } from "lucide-react";

const LogoutIconWrapper = styled.div`
    font-size: 40px !important;
`;

export const Logout = () => {
    const theme = useTheme();

    const handleLogout = () => {
        logout();
    };

    return (
        <Link to="/login" onClick={handleLogout}>
            <LogoutIconWrapper>
                <LogOut
                    style={{
                        color: theme.palette.primary.main,
                    }}
                    size={32}

                    // htmlColor={theme.palette.common.black} fontSize="inherit"
                />
            </LogoutIconWrapper>
        </Link>
    );
};
